import React from 'react';
import Select from 'react-select/lib/Async';

const AsyncSelect = ({ loadOptions, placeholder,  ...props }) => {
    return (
        <Select
            {...props}
            classNamePrefix="async-select"
            cacheOptions
            defaultOptions
            loadOptions={loadOptions}
            placeholder={placeholder || 'selecione...'}
            noOptionsMessage={() => 'nenhum resultado encontrado.'}
            loadingMessage={() => 'buscando...'}
        />
    );
}

export { AsyncSelect }
